export default {
    icoev_main_url: 'https://icoev-dev.vbote.com',
 icoev_service_url : 'https://icoev-dev.vbote.com/api/v1/',
    icoev_gtag_id: 'G-BXW6YMCGZD',
version : '1.0.192' ,
};